export const IconFileNames = [
  'file-alert',
  'file-doc',
  'file-docx',
  'file-jpg',
  'file-pdf',
  'file-png',
  'file-unknown',
  'file-xls',
  'file-xlsm',
  'file-xlsx',
  'file-zip',
] as const;

export const IconNames = [
  'delete',
  'download',
  'excel-export',
  'file-move',
  'filter-active',
  'filter',
  'settings-active',
  'sorting-asc',
  'sorting-desc',
  'sorting-non',
  'upload-batch',
  'upload-zip',
  'upload',
  'user',
  'close',
  'comment',
  'retry',
  ...IconFileNames,
];

export type SVGIconProps = {
  className?: string;
  name: (typeof IconNames)[number];
};

export function SVGIcon({ className, name }: SVGIconProps) {
  const dataTestId = `svg-icon-${name}`;

  switch (name) {
    case 'delete':
      return (
        <svg
          data-testid={dataTestId}
          className={className}
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.5 4H16L15 3H10L9 4H5.5V6H19.5M6.5 19C6.5 19.5304 6.71071 20.0391 7.08579 20.4142C7.46086 20.7893 7.96957 21 8.5 21H16.5C17.0304 21 17.5391 20.7893 17.9142 20.4142C18.2893 20.0391 18.5 19.5304 18.5 19V7H6.5V19Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'download':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2ZM12 19L8 15H10.5V12H13.5V15H16L12 19ZM13 9V3.5L18.5 9H13Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'excel-export':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2ZM15.8 20H14L12 16.6L10 20H8.2L11.1 15.5L8.2 11H10L12 14.4L14 11H15.8L12.9 15.5L15.8 20ZM13 9V3.5L18.5 9H13Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'file-alert':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M12 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H16C16.5304 22 17.0391 21.7893 17.4142 21.4142C17.7893 21.0391 18 20.5304 18 20V8L12 2Z"
            fill="white"
          />
          <path
            d="M20 17H22V15H20V17ZM20 7V13H22V7M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M11 3.5L16.5 9H11V3.5Z"
            fill="#AE242D"
          />
        </svg>
      );
    case 'file-doc':
    case 'file-docx':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 2H14L20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2ZM13 3.5V9H18.5L13 3.5ZM8.71191 20L6.57275 10.7578H8.15332L9.60025 17.6538L11.3716 10.7578H12.7109L14.4625 17.6665L15.8975 10.7578H17.4844L15.3452 20H13.7964L12.0429 13.3024L10.2607 20H8.71191Z"
            fill="#185ABD"
          />
        </svg>
      );
    case 'file-move':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M23 19L20 16V18H16V20H20V22L23 19ZM13 19C13 18.7 13 18.3 13.1 18C13.2 17.7 13.3 16.8 13.8 16C14.3 15.2 14.9 14.5 15.7 14C16.5 13.5 17.7 13.2 18 13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V8L14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H13.8C13.3 21.1 13 20.1 13 19ZM13 3.5L18.5 9H13V3.5Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'file-png':
    case 'file-jpg':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            fill="white"
          />
          <path
            d="M13 9H18.5L13 3.5V9ZM6 2H14L20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C4.89 22 4 21.1 4 20V4C4 2.89 4.89 2 6 2ZM6 20H15H18V12L14 16L12 14L6 20ZM8 9C7.46957 9 6.96086 9.21071 6.58579 9.58579C6.21071 9.96086 6 10.4696 6 11C6 11.5304 6.21071 12.0391 6.58579 12.4142C6.96086 12.7893 7.46957 13 8 13C8.53043 13 9.03914 12.7893 9.41421 12.4142C9.78929 12.0391 10 11.5304 10 11C10 10.4696 9.78929 9.96086 9.41421 9.58579C9.03914 9.21071 8.53043 9 8 9Z"
            fill="#2CB0DA"
          />
        </svg>
      );
    case 'file-pdf':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            fill="white"
          />
          <path
            d="M12.6 12.3H10.6V15.5H12.7C13.3 15.5 13.6 15.3 13.9 15C14.2 14.7 14.3 14.4 14.3 13.9C14.3 13.4 14.2 13.1 13.9 12.8C13.6 12.5 13.2 12.3 12.6 12.3ZM14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2ZM15.2 16C14.6 16.5 14.1 16.7 12.8 16.7H10.6V20H9V11H12.8C14.1 11 14.7 11.3 15.2 11.8C15.8 12.4 16 13 16 13.9C16 14.8 15.8 15.5 15.2 16ZM13 9V3.5L18.5 9H13Z"
            fill="#C4331D"
          />
        </svg>
      );
    case 'file-unknown':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            fill="white"
          />
          <path
            d="M13 9V3.5L18.5 9M6 2C4.89 2 4 2.89 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2H6Z"
            fill="#071720"
          />
        </svg>
      );
    case 'file-xls':
    case 'file-xlsx':
    case 'file-xlsm':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            fill="white"
          />
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2ZM15.8 20H14L12 16.6L10 20H8.2L11.1 15.5L8.2 11H10L12 14.4L14 11H15.8L12.9 15.5L15.8 20ZM13 9V3.5L18.5 9H13Z"
            fill="#107C41"
          />
        </svg>
      );
    case 'file-zip':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 2H14L20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2ZM13 3.5V9H18.5L13 3.5ZM15.4785 20V18.7368H10.5204L15.3325 11.7417V10.7578H8.62305V12.0273H13.4062L8.58496 18.9907V20H15.4785Z"
            fill="#DAB42C"
          />
        </svg>
      );
    case 'filter':
      return (
        <svg
          data-testid={dataTestId}
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M14 12V19.88C14.04 20.18 13.94 20.5 13.71 20.71C13.32 21.1 12.69 21.1 12.3 20.71L10.29 18.7C10.06 18.47 9.96001 18.16 10 17.87V12H9.97001L4.21001 4.62C3.87001 4.19 3.95001 3.56 4.38001 3.22C4.57001 3.08 4.78001 3 5.00001 3H19C19.22 3 19.43 3.08 19.62 3.22C20.05 3.56 20.13 4.19 19.79 4.62L14.03 12H14Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'filter-active':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 1 24 25" // The icon has margin on top, so the view box is moved down as compensation
          fill="none"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9345 12.8412C13.1773 13.8876 12 15.8063 12 18C12 19.7413 12.7418 21.3093 13.9266 22.4054C13.8767 22.5194 13.8043 22.624 13.71 22.71C13.32 23.1 12.69 23.1 12.3 22.71L10.29 20.7C10.06 20.47 9.96001 20.16 10 19.87V14H9.97001L4.21001 6.62C3.87001 6.19 3.95001 5.56 4.38001 5.22C4.57001 5.08 4.78001 5 5.00001 5H19C19.22 5 19.43 5.08 19.62 5.22C20.05 5.56 20.13 6.19 19.79 6.62L14.9345 12.8412Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 14.4295L17.2658 21L14 17.8136L15.3289 16.3841L17.2658 18.2739L22.6711 13L24 14.4295Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'locked':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.3 9.5H8.2C8.3 7.4 9.7 4.8 12.4 4.8C15 4.8 16.5 7.5 16.6 9.5H18.5C18.5 5.8 16.5 3 12.4 3C8.4 3 6.3 5.8 6.3 9.5ZM5 11.8V18.7C5 19.8 5.4 20.4 6.5 20.4H18.2C19.3 20.4 19.8 19.9 19.8 18.8V11.8C19.8 10.7 19.6 10.5 18.5 10.5H6.3C5.3 10.6 5 10.8 5 11.8ZM13.8 14.6C13.8 15.2 13.6 15.6 13.3 16L13.7 18H11.1L11.5 16C11.2 15.5 11 15.3 11 14.6C11 13.8 11.7 13.3 12.5 13.3C13.3 13.3 13.8 13.9 13.8 14.6Z"
            fill="currentColor"
          />
        </svg>
      );

    case 'retry':
      return (
        <svg
          data-testid={dataTestId}
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M6.85 6.35C8.3 4.9 10.29 4 12.5 4C14.6217 4 16.6566 4.84285 18.1569 6.34315C19.6571 7.84344 20.5 9.87827 20.5 12C20.5 14.1217 19.6571 16.1566 18.1569 17.6569C16.6566 19.1571 14.6217 20 12.5 20C8.77 20 5.66 17.45 4.77 14H6.85C7.67 16.33 9.89 18 12.5 18C14.0913 18 15.6174 17.3679 16.7426 16.2426C17.8679 15.1174 18.5 13.5913 18.5 12C18.5 10.4087 17.8679 8.88258 16.7426 7.75736C15.6174 6.63214 14.0913 6 12.5 6C10.84 6 9.36 6.69 8.28 7.78L11.5 11H4.5V4L6.85 6.35Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'settings-active':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.52521 14.9749C10.1816 15.6313 11.0718 16 12.0001 16C12.1907 16 12.3797 15.9844 12.5655 15.954C12.2028 16.7269 12.0001 17.5898 12.0001 18.5C12.0001 20.0367 12.5778 21.4385 13.5279 22.5H10.0001C9.75008 22.5 9.54008 22.32 9.50008 22.08L9.13008 19.43C8.50008 19.18 7.96008 18.84 7.44008 18.44L4.95008 19.45C4.73008 19.53 4.46008 19.45 4.34008 19.23L2.34008 15.77C2.21008 15.55 2.27008 15.28 2.46008 15.13L4.57008 13.47C4.53008 13.15 4.50008 12.83 4.50008 12.5C4.50008 12.17 4.53008 11.84 4.57008 11.5L2.46008 9.87C2.27008 9.72 2.21008 9.45 2.34008 9.23L4.34008 5.77C4.46008 5.55 4.73008 5.46 4.95008 5.55L7.44008 6.55C7.96008 6.16 8.50008 5.82 9.13008 5.57L9.50008 2.92C9.54008 2.68 9.75008 2.5 10.0001 2.5H14.0001C14.2501 2.5 14.4601 2.68 14.5001 2.92L14.8701 5.57C15.5001 5.82 16.0401 6.16 16.5601 6.55L19.0501 5.55C19.2701 5.46 19.5401 5.55 19.6601 5.77L21.6601 9.23C21.7801 9.45 21.7301 9.72 21.5401 9.87L19.4301 11.5C19.4701 11.84 19.5001 12.17 19.5001 12.5C19.5001 12.5631 19.499 12.6258 19.4969 12.6882C19.0185 12.5653 18.5169 12.5 18.0001 12.5C17.0899 12.5 16.227 12.7027 15.4541 13.0654C15.4845 12.8796 15.5001 12.6906 15.5001 12.5C15.5001 11.5717 15.1313 10.6815 14.475 10.0251C13.8186 9.36875 12.9283 9 12.0001 9C11.0718 9 10.1816 9.36875 9.52521 10.0251C8.86883 10.6815 8.50008 11.5717 8.50008 12.5C8.50008 13.4283 8.86883 14.3185 9.52521 14.9749Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 14.9295L17.2658 21.5L14 18.3136L15.3289 16.8841L17.2658 18.7739L22.6711 13.5L24 14.9295Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'settings-invisible':
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 15.5C11.0717 15.5 10.1815 15.1313 9.52512 14.4749C8.86874 13.8185 8.49999 12.9283 8.49999 12C8.49999 11.0717 8.86874 10.1815 9.52512 9.52513C10.1815 8.86875 11.0717 8.5 12 8.5C12.9283 8.5 13.8185 8.86875 14.4749 9.52513C15.1312 10.1815 15.5 11.0717 15.5 12C15.5 12.1906 15.4844 12.3796 15.454 12.5654C16.2269 12.2027 17.0898 12 18 12C18.5168 12 19.0184 12.0653 19.4968 12.1882C19.4989 12.1258 19.5 12.0631 19.5 12C19.5 11.67 19.47 11.34 19.43 11L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.96 19.05 5.05L16.56 6.05C16.04 5.66 15.5 5.32 14.87 5.07L14.5 2.42C14.46 2.18 14.25 2 14 2H9.99999C9.74999 2 9.53999 2.18 9.49999 2.42L9.12999 5.07C8.49999 5.32 7.95999 5.66 7.43999 6.05L4.94999 5.05C4.72999 4.96 4.45999 5.05 4.33999 5.27L2.33999 8.73C2.20999 8.95 2.26999 9.22 2.45999 9.37L4.56999 11C4.52999 11.34 4.49999 11.67 4.49999 12C4.49999 12.33 4.52999 12.65 4.56999 12.97L2.45999 14.63C2.26999 14.78 2.20999 15.05 2.33999 15.27L4.33999 18.73C4.45999 18.95 4.72999 19.03 4.94999 18.95L7.43999 17.94C7.95999 18.34 8.49999 18.68 9.12999 18.93L9.49999 21.58C9.53999 21.82 9.74999 22 9.99999 22H13.5278C12.5777 20.9385 12 19.5367 12 18C12 17.0898 12.2027 16.2269 12.5654 15.454C12.3796 15.4844 12.1906 15.5 12 15.5Z"
            fill="currentColor"
          />
          <path
            d="M17 22V19H14V17H17V14H19V17H22V19H19V22H17Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'sorting-asc':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <path
            d="M8 0L11.4641 6H4.5359L8 0Z"
            fill="var(--ag-foreground-color)"
          />
          <path d="M8 16L4.5359 10L11.4641 10L8 16Z" fill="currentColor" />
        </svg>
      );
    case 'sorting-desc':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <path d="M8 0L11.4641 6H4.5359L8 0Z" fill="currentColor" />
          <path
            d="M8 16L4.5359 10L11.4641 10L8 16Z"
            fill="var(--ag-foreground-color)"
          />
        </svg>
      );
    case 'sorting-non':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <path d="M8 0L11.4641 6H4.5359L8 0Z" fill="currentColor" />
          <path d="M8 16L4.5359 10L11.4641 10L8 16Z" fill="currentColor" />
        </svg>
      );
    case 'upload-batch':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 3H16L22 9V21C22 21.5304 21.7893 22.0391 21.4142 22.4142C21.0391 22.7893 20.5304 23 20 23H8C7.46957 23 6.96086 22.7893 6.58579 22.4142C6.21071 22.0391 6 21.5304 6 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V3C2 2.46957 2.21071 1.96086 2.58579 1.58579C2.96086 1.21071 3.46957 1 4 1H12L14 3ZM8 3H4V19H6V5C6 4.46957 6.21071 3.96086 6.58579 3.58579C6.96086 3.21071 7.46957 3 8 3ZM15.5 20V17H18L14 13L10 17H12.5V20H15.5ZM15 4.5V10H20.5L15 4.5Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'upload-zip':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2H14L20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2V4H8V6H6V8H8V10H6V12H8V10H10V8H8V6H10V4H8V2ZM13.5 19V16H16L12 12L8 16H10.5V19H13.5ZM13 3.5V9H18.5L13 3.5Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'upload':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2ZM13.5 16V19H10.5V16H8L12 12L16 16H13.5ZM13 9V3.5L18.5 9H13Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'user':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM5 17C5 14.4431 6.91924 12.3345 9.3957 12.0361C10.0955 12.6369 11.0053 13 12 13C12.9947 13 13.9045 12.6369 14.6043 12.0361C17.0808 12.3345 19 14.4431 19 17V20H5V17Z"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          data-testid={dataTestId}
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
          fill="none"
          className={className}
        >
          <path
            fill="currentColor"
            d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
          />
        </svg>
      );
    case 'comment':
      return (
        <svg
          data-testid={dataTestId}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 5C4.44772 5 4 5.44772 4 6V12V13V18L8 14H18C18.5523 14 19 13.5523 19 13V6C19 5.44772 18.5523 5 18 5H5Z"
          />
        </svg>
      );

    default:
      return null;
  }
}

export const isSupportedFileIcon = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any
): icon is (typeof IconFileNames)[number] => IconFileNames.includes(icon);
